import { WarningCircle, MagnifyingGlass, AirplaneTilt, Anchor } from '@phosphor-icons/react';

function getStatusColor(status) {
  const map = { reported: 'bg-amber-100 text-amber-800', approved: 'bg-green-100 text-green-800', rejected: 'bg-red-100 text-red-800', initiated: 'bg-amber-100 text-amber-800', team_assignment: 'bg-blue-100 text-blue-800', in_progress: 'bg-purple-100 text-purple-800', completed: 'bg-green-100 text-green-800' };
  return map[status] || 'bg-slate-100 text-slate-800';
}

export function RecentActivity({ incidents, investigations }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Recent Incidents */}
      <div className="bg-white rounded-xl p-6 border border-slate-200" data-testid="recent-incidents">
        <div className="flex items-center gap-2 mb-4">
          <WarningCircle size={20} weight="duotone" className="text-red-600" />
          <h2 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit' }}>Recent Notifications</h2>
        </div>
        {incidents.length === 0 ? (
          <div className="text-center py-8 text-slate-400"><p>No incidents reported yet</p></div>
        ) : (
          <div className="space-y-2">
            {incidents.slice(0, 5).map(inc => (
              <div key={inc.id} className="flex items-center justify-between p-3 rounded-lg border border-slate-100 hover:bg-slate-50">
                <div className="flex items-center gap-3">
                  {inc.sector === 'aviation' ? <AirplaneTilt size={16} className="text-blue-500" /> : <Anchor size={16} className="text-cyan-500" />}
                  <div>
                    <div className="text-sm font-medium text-slate-900">{inc.incident_number}</div>
                    <div className="text-xs text-slate-500">{inc.location} - {inc.date_occurred}</div>
                  </div>
                </div>
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(inc.status)}`}>{inc.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Active Investigations */}
      <div className="bg-white rounded-xl p-6 border border-slate-200" data-testid="recent-investigations">
        <div className="flex items-center gap-2 mb-4">
          <MagnifyingGlass size={20} weight="duotone" className="text-blue-600" />
          <h2 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit' }}>Active Investigations</h2>
        </div>
        {investigations.length === 0 ? (
          <div className="text-center py-8 text-slate-400"><p>No investigations yet</p></div>
        ) : (
          <div className="space-y-2">
            {investigations.slice(0, 5).map(inv => (
              <div key={inv.id} className="flex items-center justify-between p-3 rounded-lg border border-slate-100 hover:bg-slate-50">
                <div className="flex items-center gap-3">
                  {inv.sector === 'aviation' ? <AirplaneTilt size={16} className="text-blue-500" /> : <Anchor size={16} className="text-cyan-500" />}
                  <div>
                    <div className="text-sm font-medium text-slate-900">{inv.investigation_number}</div>
                    <div className="text-xs text-slate-500">{inv.lead_investigator || <span className="text-amber-600">Unassigned</span>}</div>
                  </div>
                </div>
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(inv.status)}`}>{inv.status?.replace('_', ' ')}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
